import React from 'react'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import {
  TextField,
  FormControl, IconButton, Tooltip,
  InputLabel, InputAdornment, ClickAwayListener, FormHelperText
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import InfoIcon from '@material-ui/icons/Info'
import ClearIcon from '@material-ui/icons/Clear'
import { lg } from '../utils/ResponsiveUtility'
import { ButtonLoader } from '../components/Loader/ButtonLoader'

const FormTextField = ({ formActions, classes, name, labelKey, label, placeholderKey, required, onChange, onBlurFn, email, row, singleRow, lines, switchEdit, switchEditValue, handleSwitchEdit, info, infoKey, disabled, otherAttributes = {}, InputAttributes = {}, value, originValue, small, large, invalidTRN, specialError, numberFormatted, hasLoading, hasClear }) => {
  const intl = useIntl()
  const [width, setWidth] = React.useState(document.body.clientWidth)
  let Mobile = (width < lg)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  const [tooltipOpen, setTooltipOpen] = React.useState(false)
  const [editTooltipOpen, setEditTooltipOpen] = React.useState(false)

  const handleTooltipClose = () => {
    setTooltipOpen(false)
  }

  const ToggleTooltipOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setTooltipOpen(!tooltipOpen)
  }

  const handleEditTooltipClose = () => {
    setEditTooltipOpen(false)
  }

  const handleEditTooltipOpen = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setEditTooltipOpen(true)
    handleSwitchEdit(!switchEditValue)
  }
  const handleClearButton = (e) => {
    e.preventDefault()
    e.stopPropagation()
    formActions.setFieldValue(name, '')
  }

  const loading = hasLoading && {
    endAdornment:
      <InputAdornment position="end">
        <ButtonLoader loading={true}/>
      </InputAdornment>
  }
  const clear = hasClear && {
    endAdornment:
      <InputAdornment position="end">
        <IconButton size={'small'} color={'primary'} onClick={handleClearButton}
        >
          <ClearIcon/>
        </IconButton>
      </InputAdornment>
  }

  const editSwitch = {
    endAdornment: (
      <InputAdornment position="end">
        {!!Mobile ?
          <ClickAwayListener onClickAway={handleEditTooltipClose}>
        <span><Tooltip
          open={editTooltipOpen}
          onClose={handleEditTooltipClose}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={intl.formatMessage({ id: `SwitchEdit.${!!switchEditValue}` })}
          arrow>
          <IconButton size={'small'} color={'primary'}
                      onClick={handleEditTooltipOpen}
                      onMouseDown={handleEditTooltipOpen}
          >
            {!!switchEditValue ? <FlashOnIcon/> : <EditIcon/>}
          </IconButton>
        </Tooltip></span>
          </ClickAwayListener>
          : <Tooltip title={intl.formatMessage({ id: `SwitchEdit.${!!switchEditValue}` })} arrow>
            <IconButton size={'small'} color={'primary'}
                        onClick={() => handleSwitchEdit(!switchEditValue)}
                        onMouseDown={() => handleSwitchEdit(!switchEditValue)}
            >
              {!!switchEditValue ? <FlashOnIcon/> : <EditIcon/>}
            </IconButton>
          </Tooltip>
        }

      </InputAdornment>
    )
  }
  let newClasses = [
    !!row ? classes.FormRow : '',
    !!small ? classes.FormSmall : '',
    !!large ? classes.FormLarge : '',
    !!singleRow ? classes.SingleRow : ''
  ].filter(item => !!item).join(' ')
  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      <InputLabel htmlFor={name}>{label ?? <FormattedMessage id={labelKey}/>}{!!required &&
      <span className={'required'}>*</span>}: {!!info && (!!Mobile ?
        <ClickAwayListener onClickAway={handleTooltipClose}>
        <span><Tooltip
          PopperProps={{
            disablePortal: true
          }}
          open={tooltipOpen}
          onClose={handleTooltipClose}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={intl.formatMessage({ id: infoKey })}
          arrow>
        <InfoIcon onClick={ToggleTooltipOpen}/>
        </Tooltip></span>
        </ClickAwayListener> : <Tooltip
          title={intl.formatMessage({ id: infoKey })} arrow><InfoIcon/></Tooltip>)
      }</InputLabel>
      <FormControl variant="outlined">
        <TextField
          required={required}
          fullWidth
          disabled={!!disabled || (!!switchEdit && !switchEditValue)}
          multiline={(lines || 1) > 1}
          rows={lines || 1}
          margin="dense"
          type={!!email ? 'email' : 'text'}
          name={name}
          id={name}
          variant="outlined"
          InputProps={!!switchEdit ? { ...editSwitch, ...InputAttributes } : { ...clear, ...loading, ...InputAttributes }}
          placeholder={label ?? intl.formatMessage({ id: placeholderKey ?? labelKey })}
          onChange={(e) => {
            !disabled && (!!onChange ? onChange(e) : formActions.handleChange(e))
          }}
          onBlur={(e) => {
            !!onBlurFn && onBlurFn(e)
            formActions.handleBlur(e)
          }}
          value={!!numberFormatted ? intl.formatNumber(value ?? formActions.values[name], { minimumFractionDigits: 2 }) : (value ?? formActions.values[name])}
          helperText={((formActions.errors[name] && formActions.touched[name]) || !!invalidTRN) && (formActions.errors[name] || invalidTRN)}
          error={((formActions.errors[name] && (formActions.touched[name] !== undefined && formActions.touched[name] !== false)) || !!invalidTRN)}
          {...otherAttributes}
        />
        {originValue != null && (
          <FormHelperText><FormattedMessage id={'OriginalValue'}/>: <strong><FormattedNumber value={originValue}
                                                                                             minimumFractionDigits={2}/></strong></FormHelperText>
        )}
        {!!specialError && (
          <FormHelperText error={true}>{specialError}</FormHelperText>
        )}
      </FormControl>
    </div>
  )
}

export default FormTextField
